import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { StageConfigPanel } from "./StageConfigPanel";

type StageConfigButtonProps = {
  /** Optional override for the icon button size. */
  size?: "small" | "medium" | "large";
};

/**
 * Gear button that opens the StageConfigPanel. Shared by the chat header and the
 * splash screen so the "Proposal Generation" config is reachable from both.
 */
export const StageConfigButton = ({
  size = "small",
}: StageConfigButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Configure Proposal Generation">
        <IconButton
          size={size}
          onClick={() => setOpen(true)}
          data-testid="propgen-btn-stage-config"
          aria-label="Configure Proposal Generation"
        >
          <SettingsOutlinedIcon
            fontSize={size === "large" ? "medium" : "small"}
          />
        </IconButton>
      </Tooltip>
      <StageConfigPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
};
